import { observer } from "mobx-react";
import { FunctionComponent, useContext, useEffect } from "react";
import {Context} from "../../store/context"

/**
 * Dynamically set document title to the building name, whenever selected building changes
 */
const SiteTitle: FunctionComponent = observer(() => {
  const { buildingsStore } = useContext(Context)
  
  useEffect(() => {
    if (buildingsStore.building) {
      document.title = `${buildingsStore.building.name} - Wayfinding`;
    }
  }, [buildingsStore.building]);
  return null;
});

export default SiteTitle;
